import { FC } from 'react'

import { IconName, SymbolBadge, Tooltip } from 'ui/components'
import { CRBLicenseStatus } from '~bank-crb-monitor/types'

import { s } from './styles'

export const CRBStatus: FC<{ icon: CRBLicenseStatus; status: string }> = ({ icon, status }) => {
  switch (icon) {
    case null:
      return null
    case 'active':
      return (
        <s.Container>
          <SymbolBadge color="positive" icon={IconName.CHECK_ROUND} />
          {status}
        </s.Container>
      )
    case 'inactive':
      return (
        <Tooltip id="checkbox" type="dark" event="hover" content="License is currently not active">
          <s.Container>
            <SymbolBadge color="error" icon={IconName.CROSS_ROUND} />
            {status}
          </s.Container>
        </Tooltip>
      )
    case 'suspended':
      return (
        <Tooltip id="checkbox" type="dark" event="hover" content="License is temporarily paused">
          <s.Container>
            <SymbolBadge color="warning" icon={IconName.INFO_ROUND} />
            {status}
          </s.Container>
        </Tooltip>
      )
    case 'warning':
      return (
        <s.Container>
          <SymbolBadge color="warning" icon={IconName.INFO_ROUND} />
          {status}
        </s.Container>
      )
    case 'waiting':
      return (
        <Tooltip id="checkbox" type="dark" event="hover" content="Awaiting review and processing">
          <s.Container>
            <SymbolBadge color="default" icon={IconName.REPEAT} />
            {status}
          </s.Container>
        </Tooltip>
      )
    default:
      return status
  }
}
